import { __read, __spread } from "tslib";
import { extractEvent, fillWithEmptyKeys } from '../../utils';
export var transformExtraction = function (_a) {
    var result = _a.result;
    var data = [];
    var keys = [];
    result.forEach(function (event) {
        var properties = Object.keys(event);
        if (properties.length !== 0) {
            var extractedEvent = extractEvent(event);
            data.push(extractedEvent);
            keys = __spread(keys, Object.keys(extractedEvent));
        }
    });
    if (keys.length) {
        keys = __spread(new Set(keys));
        data = fillWithEmptyKeys(keys, data);
    }
    return {
        data: data,
        keys: keys,
    };
};
